module.exports = __webpack_public_path__ + "img/market.cfe78f96.svg";